import { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { packs, products } from '../../mocks/products';
import Button from '../../components/base/Button';

export default function PackageDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const pack = packs.find(p => p.id === Number(id));

  if (!pack) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Paquete no encontrado</h2>
          <Link to="/paquetes">
            <Button>Volver a Paquetes</Button>
          </Link>
        </div>
      </div>
    );
  }

  const handleBuyNow = () => {
    const cartItems = pack.items.map(item => {
      const product = products.find(p => p.id === item.productId);
      return {
        productId: item.productId,
        name: item.name,
        quantity: item.quantity,
        unitPrice: product?.unitPrice || 0,
        totalPrice: (product?.unitPrice || 0) * item.quantity,
        image: product?.image || '',
        isPackItem: true,
        packName: pack.name
      };
    });

    localStorage.setItem('cart', JSON.stringify(cartItems));
    navigate('/checkout');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6">
            <Link to="/paquetes" className="text-orange-600 hover:text-orange-700 font-medium text-sm cursor-pointer inline-flex items-center">
              <i className="ri-arrow-left-line mr-2"></i>
              Volver a Paquetes
            </Link>
          </div>

          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="relative h-96 overflow-hidden">
              <img 
                src={pack.image} 
                alt={pack.name}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-8 left-8 right-8">
                <h1 className="text-5xl font-bold text-white mb-4">
                  {pack.name}
                </h1>
                {pack.freeShipping && (
                  <div className="inline-flex items-center bg-green-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                    <i className="ri-truck-line mr-2"></i>
                    Envío Gratuito Incluido
                  </div>
                )}
              </div>
            </div>

            <div className="p-8 lg:p-12">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
                <div className="lg:col-span-2">
                  <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">Descripción del Paquete</h2>
                    <p className="text-gray-600 leading-relaxed text-lg">
                      {pack.description}
                    </p>
                  </div>

                  <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">Productos Incluidos</h2>
                    <div className="space-y-4">
                      {pack.items.map((item, idx) => {
                        const product = products.find(p => p.id === item.productId);
                        return (
                          <div key={idx} className="flex items-center space-x-4 bg-gray-50 rounded-lg p-4">
                            <div className="w-24 h-24 rounded-lg overflow-hidden bg-white flex-shrink-0">
                              <img 
                                src={product?.image} 
                                alt={item.name}
                                className="w-full h-full object-cover object-top"
                              />
                            </div>
                            <div className="flex-1">
                              <h3 className="font-semibold text-gray-900 text-lg mb-1">
                                {item.name}
                              </h3>
                              <p className="text-sm text-gray-600 mb-2">
                                {product?.description.substring(0, 100)}...
                              </p>
                              <div className="flex items-center space-x-4">
                                <span className="text-sm text-gray-600">
                                  Cantidad: <strong className="text-gray-900">{item.quantity} unidades</strong>
                                </span>
                                <span className="text-sm text-gray-600">
                                  Precio: <strong className="text-orange-600">{product?.unitPrice.toFixed(2)}€/ud</strong>
                                </span>
                              </div>
                            </div>
                            <Link to={`/producto/${item.productId}`}>
                              <button className="px-4 py-2 text-sm text-orange-600 hover:bg-orange-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                                Ver Detalles
                              </button>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">Ventajas de Este Paquete</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex items-start space-x-3">
                        <i className="ri-checkbox-circle-fill text-orange-600 text-xl mt-1"></i>
                        <div>
                          <h3 className="font-semibold text-gray-900 mb-1">Ahorro Garantizado</h3>
                          <p className="text-sm text-gray-600">Precio especial en pack vs compra individual</p>
                        </div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <i className="ri-checkbox-circle-fill text-orange-600 text-xl mt-1"></i>
                        <div>
                          <h3 className="font-semibold text-gray-900 mb-1">Envío Gratuito</h3>
                          <p className="text-sm text-gray-600">Sin costes adicionales de transporte</p>
                        </div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <i className="ri-checkbox-circle-fill text-orange-600 text-xl mt-1"></i>
                        <div>
                          <h3 className="font-semibold text-gray-900 mb-1">Stock Inmediato</h3>
                          <p className="text-sm text-gray-600">Disponibilidad garantizada de todos los productos</p>
                        </div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <i className="ri-checkbox-circle-fill text-orange-600 text-xl mt-1"></i>
                        <div>
                          <h3 className="font-semibold text-gray-900 mb-1">Envío Rápido</h3>
                          <p className="text-sm text-gray-600">Procesamos tu pedido en 24-48 horas</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lg:col-span-1">
                  <div className="bg-gray-50 rounded-xl p-8 sticky top-32">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">Resumen del Paquete</h3>
                    
                    <div className="space-y-4 mb-6">
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">Total unidades:</span>
                        <span className="text-lg font-semibold text-gray-900">{pack.totalItems}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">Precio regular:</span>
                        <span className="text-lg text-gray-500 line-through">{pack.regularPrice.toFixed(2)}€</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">Precio pack:</span>
                        <span className="text-2xl font-bold text-orange-600">{pack.packPrice.toFixed(2)}€</span>
                      </div>
                      <div className="flex justify-between items-center pt-4 border-t border-gray-200">
                        <span className="text-gray-900 font-semibold">Tu ahorro:</span>
                        <span className="text-xl font-bold text-green-600">{pack.savings.toFixed(2)}€</span>
                      </div>
                    </div>

                    <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
                      <div className="flex items-center space-x-2 text-green-700">
                        <i className="ri-truck-line text-xl"></i>
                        <span className="font-semibold text-sm">Envío Gratuito</span>
                      </div>
                    </div>

                    <Button 
                      fullWidth 
                      size="lg"
                      onClick={handleBuyNow}
                      className="mb-4"
                    >
                      Comprar Ahora
                      <i className="ri-shopping-cart-line ml-2"></i>
                    </Button>

                    <Link to="/contacto">
                      <Button 
                        fullWidth 
                        size="lg"
                        variant="outline"
                      >
                        Consultar
                        <i className="ri-mail-line ml-2"></i>
                      </Button>
                    </Link>

                    <div className="mt-6 pt-6 border-t border-gray-200">
                      <h4 className="font-semibold text-gray-900 mb-3 text-sm">¿Necesitas ayuda?</h4>
                      <p className="text-sm text-gray-600 mb-3">
                        Nuestro equipo está disponible para asesorarte
                      </p>
                      <div className="space-y-2">
                        <div className="flex items-center space-x-2 text-sm text-gray-600">
                          <i className="ri-phone-line text-orange-600"></i>
                          <span>+34 900 123 456</span>
                        </div>
                        <div className="flex items-center space-x-2 text-sm text-gray-600">
                          <i className="ri-mail-line text-orange-600"></i>
                          <span>info@ropapersonalizada.com</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}